<template>
    <div class="index">
        我是首页
    </div>
</template>

<script>

export default {
    components: {
    },
    data() {
        return {
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {},
};
</script>
<style lang='scss' scoped>
// import
</style>
